const CUSTOMER_CONST = {
    CUSTOMER_LOGIN: "CUSTOMER_LOGIN",
    CUSTOMER_LOGOUT: "CUSTOMER_LOGOUT",
    CUSTOMER_ADDRESSES: "SET_CUSTOMER_ADDRESSES",
    CUSTOMER_ORDERS: "SET_CUSTOMER_ORDERS"
}

export default CUSTOMER_CONST;